import axios from '../config/axiosConfig';
import { PACKAGE_URL } from './constant/BaseApiUrl';

export default class PackageService {
  getRoomCategoryByPackagePlus(payload) {
    return axios.post(`${PACKAGE_URL}/package-plus`, payload);
  }
}
